import FormProps from "data/forms"
import ContinuingEducationFields from "./types"
import TextInput from "Components/molecule/inputs/text-input"
import SelectInput, { SelectOption } from "Components/molecule/inputs/select-input"
import DateInput from "Components/molecule/inputs/date-input";
import TextAreaInput from "Components/molecule/inputs/textarea-inpuit";
import PrimaryButton from "Components/atoms/buttons/primary-button";
import SecondaryButton from "Components/atoms/buttons/secondary-button";
import FormContainer from "Components/atoms/containers/form-container";
import { Alert } from "reactstrap";

interface ContinuingEducationFormProps extends FormProps<ContinuingEducationFields> {
    employeeName: string
    secondaryApprovalWarning: string | null
    environments: SelectOption[]
    types: SelectOption[]
    topics: SelectOption[]
}

const COURSE_NAME_KEY = "courseName";
const COURSE_LINK_KEY = "courseLink";
const COURSE_HOURS_KEY = "courseHours";
const COURSE_START_DATE_KEY = "courseStartDate";
const COURSE_END_DATE_KEY = "courseEndDate";
const COURSE_DESCRIPTION_KEY = "courseDescription";
const COST_KEY = "cost";
const ENVIRONMENT_KEY = "environmentId";
const TYPE_KEY = "typeId";
const TOPIC_KEY = "topicId";

const ContinuingEducationForm = ({
    handleChange,
    handleBlur,
    handleSubmit,
    handleCancel,
    touched,
    values,
    errors,
    isSubmitting,
    isValid,
    employeeName,
    secondaryApprovalWarning,
    environments,
    types,
    topics,
}: ContinuingEducationFormProps) => {

    return <FormContainer
        buttonsClassName="d-flex flex-column flex-md-row gap-2"
        inputs={<>
            <TextInput
                name={"employeeName"}
                key={"employeeName"}
                label={"Employee Name"}
                value={employeeName}
                disabled
                className="col-12 col-md-4"
            />

            <TextInput
                name={COURSE_NAME_KEY}
                key={COURSE_NAME_KEY}
                label={"Course Name*"}
                placeholder={"Course Name"}
                value={values.courseName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.courseName && !!errors.courseName}
                message={touched.courseName ? errors.courseName : undefined}
                className="col-12 col-md-4"
            />

            <TextInput
                name={COURSE_LINK_KEY}
                key={COURSE_LINK_KEY}
                label={"Course Link"}
                placeholder={"Course Link"}
                value={values.courseLink}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.courseLink && !!errors.courseLink}
                message={touched.courseLink ? errors.courseLink : undefined}
                className="col-12 col-md-4"
            />

            <SelectInput
                name={TYPE_KEY}
                key={TYPE_KEY}
                label={"Type*"}
                placeholder={"Select a type"}
                options={types}
                value={values.typeId}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.typeId && !!errors.typeId}
                message={touched.typeId ? errors.typeId : undefined}
                className="col-12 col-md-4"
            />

            <SelectInput
                name={TOPIC_KEY}
                key={TOPIC_KEY}
                label={"Topic*"}
                placeholder={"Select a topic"}
                options={topics}
                value={values.topicId}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.topicId && !!errors.topicId}
                message={touched.topicId ? errors.topicId : undefined}
                className="col-12 col-md-4"
            />

            <SelectInput
                name={ENVIRONMENT_KEY}
                key={ENVIRONMENT_KEY}
                label={"Environment*"}
                placeholder={"Select an environment"}
                options={environments}
                value={values.environmentId}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.environmentId && !!errors.environmentId}
                message={touched.environmentId ? errors.environmentId : undefined}
                className="col-12 col-md-4"
            />

            <TextInput
                name={COURSE_HOURS_KEY}
                key={COURSE_HOURS_KEY}
                type="number"
                label={"Course Hours*"}
                placeholder={"Course Hours"}
                value={values.courseHours}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.courseHours && !!errors.courseHours}
                message={touched.courseHours ? errors.courseHours : undefined}
                className="col-12 col-md-2"
            />


            <TextInput
                name={COST_KEY}
                key={COST_KEY}
                type="number"
                label={"Cost (CAD)*"}
                placeholder={"Cost"}
                value={values.cost}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.cost && !!errors.cost}
                message={touched.cost ? errors.cost : undefined}
                className="col-12 col-md-2"
            />

            <DateInput
                name={COURSE_START_DATE_KEY}
                key={COURSE_START_DATE_KEY}
                label={"Course Start Date*"}
                placeholder={"Course Start Date"}
                value={values.courseStartDate}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.courseStartDate && !!errors.courseStartDate}
                message={touched.courseStartDate ? errors.courseStartDate : undefined}
                className="col-12 col-md-2"
            />

            <DateInput
                name={COURSE_END_DATE_KEY}
                key={COURSE_END_DATE_KEY}
                label={"Course End Date*"}
                placeholder={"Course End Date"}
                value={values.courseEndDate}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.courseEndDate && !!errors.courseEndDate}
                message={touched.courseEndDate ? errors.courseEndDate : undefined}
                className="col-12 col-md-2"
            />


            {secondaryApprovalWarning && (
                <Alert color="warning" className="col-12 mb-0">
                    {secondaryApprovalWarning}
                </Alert>
            )}

            <TextAreaInput
                name={COURSE_DESCRIPTION_KEY}
                key={COURSE_DESCRIPTION_KEY}
                label={"Course Description and Relation to Role*"}
                placeholder={"Course Description and Relation to Role"}
                value={values.courseDescription}
                onBlur={handleBlur}
                onChange={handleChange}
                className="col-12 text-area-input"
                error={!!touched.courseDescription && !!errors.courseDescription}
                message={touched.courseDescription ? errors.courseDescription : undefined}
                max={2000}
            />
        </>}
        buttons={<>
            <PrimaryButton
                className="col-12 col-md-6 col-lg-2"
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
            >
                {isSubmitting ? "Submitting...." : "Submit"}
            </PrimaryButton>
            {handleCancel &&
                <SecondaryButton
                    className="col-12 col-md-6 col-lg-2"
                    disabled={isSubmitting}
                    onClick={() => handleCancel()}
                >
                    Cancel
                </SecondaryButton>
            }
        </>}
    />
}


export default ContinuingEducationForm
